<template>
  <div class="w-full h-full">
    <!-- Modo upload nueva version: sin fromVersion ni temp_key → LayoutBuilder dropzone -->
    <LayoutBuilder
      v-if="mode === 'upload-new-version' && pictogram"
      :pictogram="pictogram"
      :entity-id="projectId"
      :type-pictogram="pictogram.type"
      :can-actions-pictogram="canActionsPictogram"
      :mode="mode"
      @epc-reload="_OnPictogramReload"
    />

    <!-- Modo review o restore: UpdatePictogramFlow -->
    <UpdatePictogramFlow
      v-else-if="(mode === 'review' || mode === 'restore') && pictogram"
      :pictogram="pictogram"
      :temp-key="tempKey"
      :doc-version-id="docVersionId"
      :from-version="fromVersion"
      :mode="mode"
    />

    <!-- Loading pictograma -->
    <div v-else class="p-8 text-center">
      <b-icon pack="fas" icon="spinner" custom-class="fa-spin" size="is-large"></b-icon>
      <p class="mt-2 text-sm text-gray-500">Cargando pictograma...</p>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import LayoutBuilder from '../../components/pictograms/layout-builder/LayoutBuilder.vue';
import UpdatePictogramFlow from '../../components/pictograms/components/UpdatePictogramFlow.vue';
import { getPictogram } from '../../components/pictograms/services/pictograms.service';

export default {
  name: 'AdminPictogramProcessUpdate',
  middleware: 'auth',
  title: 'Procesar pictograma',

  components: { LayoutBuilder, UpdatePictogramFlow },

  data() {
    return {
      pictogram: null,
      canActionsPictogram: {
        mode_dashboard: false,
        show_header:    true,
        save:           true,
        select_entity:  false,
      },
    };
  },

  computed: {
    ...mapGetters({ navData: 'app/navData' }),

    projectId() {
      return parseInt(this.$route.params.project_id ?? this.navData.project_id);
    },
    pictogramId() {
      return parseInt(this.$route.params.id);
    },
    fromVersion() {
      const v = this.$route.params.fromVersion;
      return v ? parseInt(v) : null;
    },
    tempKey() {
      return this.$route.query.temp_key || null;
    },
    docVersionId() {
      return this.$route.query.doc_version_id ? parseInt(this.$route.query.doc_version_id) : null;
    },

    /**
     * Modo resuelto a partir de params + query:
     *   - 'restore'             si vino con :fromVersion
     *   - 'review'              si vino con ?temp_key (redirect post-upload)
     *   - 'upload-new-version'  default — sin nada, mostrar dropzone
     */
    mode() {
      if (this.fromVersion) return 'restore';
      if (this.tempKey)      return 'review';
      return 'upload-new-version';
    },
  },

  async created() {
    await this._LoadPictogram();
  },

  methods: {
    async _LoadPictogram() {
      try {
        this.pictogram = await getPictogram(this.pictogramId);
      } catch (err) {
        console.error('No se pudo cargar el pictograma:', err);
        this.$buefy.toast.open({
          message:  'No se pudo cargar el pictograma',
          type:     'is-danger',
          position: 'is-top-right',
        });
      }
    },

    _OnPictogramReload() {
      this._LoadPictogram();
    },
  },
};
</script>
